var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-player",class:_vm.computedClass,style:({
        width:
            _vm.$player.isFullscreen && !_vm.$player.isOrientation
                ? _vm.innerHeight + 'px'
                : '100%',
    })},[_c('div',{staticClass:"c-player__body",on:{"click":_vm.handlePlayer}},[_c('c-player-bg'),_c('c-player-ctrl')],1),_c('c-player-live')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }